<template>
  <div class="container-fluid">
    <div class="row mb-1">
        <div class="col-sm text-start pb-1">
            <span class="pull-left mt-1 py-2 px-4 me-5 text-dark" style="font-size:18px; background:DarkTurquoise">
                <b>รายงานประวัติการตรวจของคนไข้และจำนวนครั้งที่ตรวจ</b>
            </span>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col-sm">
            <div class="row">
              <div class="col-sm-4">
                <!-- สาขาแล็บ -->
                <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text" style="width:100px;">สาขา* :</span>
                    <select v-model="branchSelected" class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID">
                        <option disabled value="">Please select one</option>
                        <option v-for="item in dataBranchlists" :key="item.BranchID" v-bind:value="{ BranchID: item.BranchID, BranchName: item.BranchName }">
                          {{ item.BranchName }}
                        </option>
                    </select>

                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <!-- วันที่ใบสั่งตรวจ -->
                <div class="input-group input-group-sm mb-1">
                  <span class="input-group-text" style="width:100px;" title="วันที่อนุมัติผลแล็บ">ระบุช่วงเวลา :</span>
                  <select class="form-select" id="inputGroupSelect01">
                      <option value="1">กำหนดเอง</option>
                      <option value="2">เดือนปัจจุบัน</option>
                      <option value="3">เดือนก่อนหน้า</option>
                  </select>
                  <v-date-picker mode="date" v-model="dateFm" :masks="masks">
                      <template v-slot="{ inputValue, inputEvents }">
                          <input name="dateFm" ref="dateFm" style="width:120px;"
                          class="bg-white border px-2 py-1 rounded"
                          :value="inputValue"
                          v-on="inputEvents"
                          />
                      </template>
                  </v-date-picker>
                  <v-date-picker mode="date" v-model="dateTo" :masks="masks">
                      <template v-slot="{ inputValue, inputEvents }">
                          <input name="dateTo" ref="dateTo" style="width:120px;"
                          class="bg-white border px-2 py-1 rounded"
                          :value="inputValue"
                          v-on="inputEvents"
                          />
                      </template>
                  </v-date-picker>
                  <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="refreshData()">ดึงข้อมูล</button>
                </div>
              </div>
              <div class="col-sm">
              </div>
            </div>
        </div>
    </div>
    <!-- ปุ่ม dropdown รายงาน R-S001 -->
    <div class="row mb-2">
      <div class="col text-start">
        <div class="dropdown">
          <button type="button" class="btn btn-warning dropdown-toggle" data-bs-toggle="dropdown">
            รายงานสรุปจำนวนผู้มาใช้บริการ (RS001)
          </button>
          <ul class="dropdown-menu">
            <li class="dropdown-item" @click="getDataRS001(0)">เรียงตามวันที่</li>
            <li class="dropdown-item" @click="getDataRS001(1)">เรียงตามชื่อคนไข้</li>
            <li><hr class="dropdown-divider"></li>
            <li>
                <vue-excel-xlsx class="dropdown-item" v-if="datalists!==null" title="Download to Excel File"
                  :data="datalists"
                  :columns="columns"
                  :filename="'report_summary_period(RS001)'"
                  :sheetname="'sheetname'"
                  >
                  Download
                </vue-excel-xlsx>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <RepPatSummary1PatList :key="countRefresh"
    :branchID="branchSelected.BranchID"
    :dateFm="dateFm" :dateTo="dateTo"></RepPatSummary1PatList>
    <!-- <RepPatSummary1APatList :key="countRefresh"
    :branchID="branchID"
    :dateFm="dateFm" :dateTo="dateTo"></RepPatSummary1APatList> -->
  </div>

  <!-- PRINT PDF -->
  <div id="divToPrintRS001" hidden>
    <table id="myTableRS001" data-pdfmake="{'headerRows': 1, 'layout':'lightHorizontalLines'}" style="width: 100%;">
      <thead class="text-dark" >
      <tr>
          <th>ลำดับ</th>
          <th>วันที่</th>
          <th>LAB No.</th>
          <th>HN</th>
          <th>ชื่อคนไข้</th>
          <th>เพศ</th>
          <th>อายุ</th>
          <th>เชื้อชาติ/สัญชาติ</th>
          <th>รายการตรวจ</th>
          <th>ผู้ตรวจสอบ</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in datalistsRS001" :key="item.ROID">
        <td style="text-align: right;">{{index + 1}}.</td>
        <td class="text-center">{{ item.DocDate }}</td>
        <td class="text-start">{{item.RONo}} [{{item.Status}}] </td>
        <td class="text-start">{{item.PatCode}}</td>
        <td class="text-start">{{item.PatName}} {{item.PatLName}} </td>
        <td class="text-center">{{arrSex[item.Sex]}}</td>
        <td class="text-center">{{ item.AgeYears }}</td>
        <td class="text-start"> {{ item.Race }} <span v-if="item.Race!=''">/</span> {{ item.Nationality }} </td>
        <td class="text-start">{{item.TestText}} <span v-if="item.TestText!=''">,</span> {{item.PackageText}}</td>
        <td class="text-center">{{ item.OfficerName3 }}</td>
      </tr>
      <tr>
        <td style="text-align: center;" colspan="10">
          จำนวนใบสั่งตรวจทั้งหมด <span><b>{{this.datalistsRS001.length}}</b></span> รายการ
        </td>
      </tr>
      </tbody>
    </table>
    <h5>ตารางสรุป : {{this.dateFm.toISOString().substr(0, 10)}} - {{this.dateTo.toISOString().substr(0, 10)}}</h5>
    <table id="myTableRS001Sum" style="width: 100%;">
      <tbody>
        <tr style="background-color:gray;">
          <td style="text-align: center; background-color:gray;">สรุปรวม (คน)</td>
          <td style="text-align: center; background-color:gray;">รวม</td>
          <td style="text-align: center; background-color:gray;">เพศชาย</td>
          <td style="text-align: center; background-color:gray;">เพศหญิง</td>
        </tr>
        <tr>
          <td style="text-align: left;">จำนวนผู้มารับบริการ</td>
          <td style="text-align: center;">{{this.rs001PatList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatMaleList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatFemaleList.length}}</td>
        </tr>
        <tr>
          <td style="text-align: left;"> - คนไทย</td>
          <td style="text-align: center;">{{this.rs001PatThaiList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatThaiMaleList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatThaiFemaleList.length}}</td>
        </tr>
        <tr>
          <td style="text-align: left;"> - คนต่างชาติ</td>
          <td style="text-align: center;">{{this.rs001PatForeignList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatForeignMaleList.length}}</td>
          <td style="text-align: center;">{{this.rs001PatForeignFemaleList.length}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import RepPatSummary1PatList from './RepPatSummary1PatList.vue'
// import RepPatSummary1APatList from './RepPatSummary1APatList.vue'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'RepHO',
  components: {
    RepPatSummary1PatList
  },
  data () {
    return {
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'Male', 'Female'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchSelected: { BranchID: -1, BranchName: '' },
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      status0New: false,
      status1Lab: false,
      status2Res: false,
      status3App: true,

      countRefresh: 0,
      datalists: [],
      datalistsRS001: [],
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null
    }
  },
  created () {
  },
  mounted () {
    // Initial Value
    this.getBranchData()
  },
  computed: {
    // Array PatID ของคนไข้ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'เพศชาย' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatMaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Sex === '1' || item.Sex === 1)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'เพศหญิง' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatFemaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Sex === '2' || item.Sex === 2)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'คนไทย' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatThaiList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '0' || item.Foreigner === 0)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'คนไทยเพศชาย' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatThaiMaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '0' || item.Foreigner === 0) && (item.Sex === '1' || item.Sex === 1)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'คนไทยเพศหญิง' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatThaiFemaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '0' || item.Foreigner === 0) && (item.Sex === '2' || item.Sex === 2)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'ต่างชาติ' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatForeignList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '1' || item.Foreigner === 1)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'ต่างชาติเพศชาย' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatForeignMaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '1' || item.Foreigner === 1) && (item.Sex === '1' || item.Sex === 1)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    },
    // Array PatID ของคนไข้ 'ต่างชาติเพศหญิง' ที่ไม่ซ้ำทั้งหมดตามช่วงเวลา
    rs001PatForeignFemaleList: function () {
      const result = []
      const map = new Map()
      for (const item of this.datalistsRS001) {
        if (!map.has(item.PatID) && (item.Foreigner === '1' || item.Foreigner === 1) && (item.Sex === '2' || item.Sex === 2)) {
          map.set(item.PatID, true) // set any value to Map
          result.push(item.PatID) // เก็บ คนไข้ ที่ ID ไม่ซ้ำเป็นจำนวนคนไข้ทั้งหมด
        }
      }
      return result
    }
  },
  methods: {
    refreshData () {
      this.countRefresh++
    },
    StatusLN (status) {
      return this.arrDocStatus[status]
    },
    SexMF (sex) {
      return this.arrSex[sex]
    },
    // getBranchData () {
    //   MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
    //     .then((resp) => {
    //       this.dataBranchlists = resp.data.response
    //     })
    //     .catch((err) => {
    //       console.log(err.response)
    //     })
    // },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // this.dataBranchlists = resp.data.response
          const result = []
          for (const item of resp.data.response) {
            var rowObj = { BranchID: item.BranchID, BranchName: item.BranchName }
            if (item.BranchID === this.globalBranchID) {
              this.dataBranchItem = rowObj
            }
            result.push(rowObj)
          }
          this.dataBranchlists = result
          this.$nextTick(() => {
            this.branchSelected = this.dataBranchItem
          })
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ================================================= //
    // R-S001 - รายงานสรุปจำนวนผู้มาใช้บริการ ; S=Sumary  001=Run No.
    // ================================================= //
    getDataRS001 (SortBy) { // SortBy : 0-วันที่ 1-ชื่อคนไข้
      var docDateFm = this.dateFm.toISOString().slice(0, 10)
      var docDateTo = this.dateTo.toISOString().slice(0, 10)
      var BranchID = this.branchSelected.BranchID // this.branchID
      var Status0 = -1 // 0-New
      var Status1 = -1 // 1-Lab
      var Status2 = -1 // 2-Resulted
      var Status3 = 3 // 3-Approve
      MyApiClient.get('getdata/repsumpatperiod_where.php?C1=' + this.globalCorpID + '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo +
        '&Status0=' + Status0 + '&Status1=' + Status1 + '&Status2=' + Status2 + '&Status3=' + Status3 +
        '&SortBy=' + SortBy)
      // MyApiClient.get('getdata/tests_all.php')
        .then((resp) => {
          console.log('After get by Cond..')
          console.log(resp.data.response)
          this.datalistsRS001 = resp.data.response
          if (this.datalistsRS001 == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
            this.datalistsRS001 = []
          } else {
            this.$nextTick(() => { this.createReportToScreenRS001() })
          }
          // this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    createReportToScreenRS001 () {
      const textBranch = this.branchSelected.BranchName
      const textDateFm = this.dateFm.toISOString().substr(0, 10)
      const textDateTo = this.dateTo.toISOString().substr(0, 10)
      // ==================================== //
      var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrintRS001')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      var documentDefinition = {
        // pageSize: 'LEGAL',
        pageOrientation: 'landscape',
        pageMargins: [30, 100, 30, 90],
        header: {
          columns:
          [
            { },
            {
              text: 'รายงานผู้ใช้บริการ \n' + self.globalCorpInfo.name + ' ' + textBranch + '\n' +
                    self.globalCorpInfo.addr1 + ' ' + self.globalCorpInfo.addr2 + ' ' + self.globalCorpInfo.tambol + ' ' +
                    self.globalCorpInfo.amphor + ' ' + self.globalCorpInfo.province + ' ' + self.globalCorpInfo.zipcode +
                    '\nระหว่างวันที่ ' + textDateFm + ' - ' + textDateTo,
              width: 376,
              alignment: 'center',
              lineHeight: 0.8,
              margin: [0, 20, 0, 0]
            },
            { }
          ]
        },
        footer: function (currentPage, pageCount) {
          const d = new Date()
          const textDate = d.toISOString().substr(0, 19).replace('T', ' ')
          return {
            margin: [30, 40, 30, 20],
            table: {
              // widths: [200, 150, 150],
              widths: [200, 350, 200],
              body: [
                [
                  {
                    text: 'Printed date : ' + textDate,
                    border: [0, 1, 0, 0],
                    alignment: 'left',
                    fontSize: 12
                  },
                  {
                    text: '',
                    border: [0, 1, 0, 0],
                    alignment: 'center',
                    fontSize: 12
                  },
                  {
                    text: 'Page-' + currentPage.toString() + '/' + pageCount.toString(),
                    border: [0, 1, 0, 0],
                    alignment: 'right',
                    fontSize: 12
                  }
                ]
              ]
            }
          }
        },
        content: html,
        // content: 'TEST *******************',
        style: {
          // Document Header
          documentHeaderLeft: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentHeaderCenter: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentHeaderRight: {
            fontSize: 10,
            margin: [5, 5, 5, 5],
            alignment: 'right'
          },
          // Document Footer
          documentFooterLeft: {
            fontSize: 6,
            margin: [5, 5, 5, 5],
            alignment: 'left'
          },
          documentFooterCenter: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          },
          documentFooterRight: {
            fontSize: 8,
            margin: [5, 5, 5, 5],
            alignment: 'center'
          }
        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 15,
          lineHeight: 0.7
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    }
  }
}
</script>

<style>

</style>
